module.exports = __webpack_public_path__ + "static/img/new.b64a02c9.png";